var e = function() {
  return e = Object.assign || function(s) {
    for (var r, t = 1, a = arguments.length; t < a; t++) {
      r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (s[n] = r[n]);
    }
    return s;
  }, e.apply(this, arguments);
};
function c(s, r, t) {
  if (t || arguments.length === 2) for (var a = 0, n = r.length, o; a < n; a++)
    (o || !(a in r)) && (o || (o = Array.prototype.slice.call(r, 0, a)), o[a] = r[a]);
  return s.concat(o || Array.prototype.slice.call(r));
}
export {
  e as __assign,
  c as __spreadArray
};
//# sourceMappingURL=index.es111.js.map
